/**
 * BrandedReportHeader — reusable header for all branded report PDFs/modals.
 *
 * Props:
 *   facilityName  – string
 *   facilityPhoto – url string (or null → amber circle fallback)
 *   reportTitle   – e.g. "Medication Administration Record"
 *   reportSubtitle– e.g. "March 2026 · Generated 03/26/2026"
 *   forPdf        – boolean (wider for PDF capture)
 */
import React from "react";
import moment from "moment";
import { S, BRAND } from "./reportStyles";

const ReportHeader = ({
  facilityName = "Facility",
  facilityPhoto,
  reportTitle,
  reportSubtitle,
  forPdf = false,
}) => {
  const facInitial = facilityName?.[0] || "O";

  return (
    <div style={S.pageHeader}>
      <div style={S.branding}>
        {facilityPhoto ? (
          <img
            src={facilityPhoto}
            alt=""
            crossOrigin="anonymous"
            style={S.logoImg}
          />
        ) : (
          <div style={S.logoCircle}>
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>
              {facInitial}
            </span>
          </div>
        )}
        <div>
          <div style={S.facilityName}>{facilityName}</div>
          {reportTitle && <div style={S.facilitySub}>{reportTitle}</div>}
        </div>
      </div>
      <div style={S.reportRight}>
        {reportSubtitle && <div style={S.reportSub}>{reportSubtitle}</div>}
      </div>
    </div>
  );
};

export default ReportHeader;
